export default "__VITE_ASSET__BdRQWnBx__"